































































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';

import useAuth from '@/useAuth';

import {
  getAgenda,
  createAgenda,
  updateAgenda,
} from '@/api';

import CommonTimePicker from '@/components/CommonTimePicker.vue';
import MultiselectSpeaker from '@/components/Speaker/MultiselectSpeaker.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonDropzoneWithAxios from '@/components/Dropzone/CommonDropzoneWithAxios.vue';

const PanelWithAgendaEditor = defineComponent({
  components: {
    CommonTimePicker,
    MultiselectSpeaker,
    CommonModalWithPreset,
    CommonDropzoneWithAxios,
  },
  props: {
    edit: { default() { return false; } },
  },
  setup(props: any) {
    const { route } = useRouter();
    const { hasPermission } = useAuth();
    const NOW = new Date();
    const successModal = ref(null);

    const form = reactive({
      name: '',
      nameEN: '',
      text: '',
      textEN: '',
      scheduledTime: NOW,
      startTime: '00:00',
      endTime: '00:00',
      speakers: '',
      autoDisplay: false,
      call: async () => {
        /* eslint-disable */
        if (props.edit === true) {
          await updateAgenda(route.value.params.agendaId, {
            name: form.name,
            name_en: form.nameEN,
            text: form.text,
            text_en: form.textEN,
            scheduled_time: `${form.scheduledTime} ${form.startTime}`,
            start_time: form.startTime,
            end_time: form.endTime,
            speakers: form.speakers,
            auto_display: form.autoDisplay,
          })
        } else {
          await createAgenda({
            live_session_id: route.value.params.liveId,
            name: form.name,
            name_en: form.nameEN,
            text: form.text,
            text_en: form.textEN,
            scheduled_time: `${form.scheduledTime} ${form.startTime}`,
            start_time: form.startTime,
            end_time: form.endTime,
            speakers: form.speakers,
            auto_display: form.autoDisplay,
          });
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
        /* eslint-enable */
      },
      state: {
        value: 'READY',
      },
    });

    onMounted(async () => {
      if (route.value.params.agendaId) {
        const result = await getAgenda(route.value.params.agendaId);
        form.name = result.name;
        form.nameEN = result.name_en;
        form.text = result.text;
        form.textEN = result.text_en;
        form.scheduledTime = useFormat.date(result.scheduled_time).computerShortDate();
        form.startTime = result.start_time;
        form.endTime = result.end_time;
        form.speakers = result.speakers.map((speaker: any) => speaker.id);
        form.autoDisplay = result.auto_display;
      }
    });

    return {
      form,
      successModal,
      hasPermission,
    };
  },
});

export default PanelWithAgendaEditor;
